import React, { useState } from 'react';

const VariationList = ({ variations = [], type = 'price', productId }) => {
    const [expanded, setExpanded] = useState(false);
    const visibleVariations = expanded ? variations : variations.slice(0, 2);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {visibleVariations.map((v, idx) => (
                <div
                    key={v.id || idx}
                    style={{
                        border: '1px solid #ddd',
                        padding: '6px 10px',
                        borderRadius: '6px',
                        background: '#f9f9f9',
                        fontSize: '14px'
                    }}
                >
                    {/* Attribute Details */}
                    <strong>
                        {Object.entries(v.attributes || {})
                            .map(([attrId, term]) => {
                                // Safely handle if term is missing
                                if (!term || typeof term !== 'object') return '';
                                return `${term.name}${term.unit ? ` (${term.unit})` : ''}`;
                            })
                            .join(', ')}
                    </strong>

                    {/* Price */}
                    <div style={{ color: '#222', marginTop: '2px' }}>
                        ₹ {type === 'sale' ? (v.salePrice || v.price) : v.price}
                    </div>

                    {/* Optional Stock */}
                    {v.stock && (
                        <div style={{ fontSize: '12px', color: '#777' }}>
                            Stock: {v.stock}
                        </div>
                    )}
                    {
                        v.sku && (
                            <span className="text-[11px] text-gray-500">
                                SKU: {v.sku || "N/A"}
                            </span>
                        )
                    }
                </div>
            ))}

            {/* Toggle Show More / Less */}
            {variations.length > 2 && (
                <span
                    style={{ color: '#007bff', cursor: 'pointer', fontSize: '13px', marginTop: '4px' }}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Show less' : `Show ${variations.length - 2} more`}
                </span>
            )}
        </div>
    );
};

export default VariationList;
